import { render, staticRenderFns } from "./ManageChartsView.vue?vue&type=template&id=7f1085e4&"
import script from "./ManageChartsView.vue?vue&type=script&lang=ts&"
export * from "./ManageChartsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports